'use client';
/**
 * Created by nicolas.looschen@pikobytes.de on 11.02.2025.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import { Box, Divider as MuiDivider, useTheme } from '@mui/material';
import { BASE_PATH } from '../../typedefs/constants';

export enum DividerVariants {
    HOME = 'home',
    SECTION_START = 'section-start',
    SECTION_END = 'section-end',
}

export const Divider = (props: {
    variant?: DividerVariants | `${DividerVariants}`;
}) => {
    const theme = useTheme();

    return (
        <Box
            className={props.variant}
            sx={{
                position: 'relative',
                height: 50,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 1,
                '.divider-logo-decoration-container': {
                    height: 50,
                    width: 52,
                    px: '10px',
                    py: '7px',
                    zIndex: 2,
                    backgroundColor: 'white',
                    '.divider-logo-decoration': {
                        background: `url(${BASE_PATH}static/images/logo-small-variant.svg) no-repeat`,
                        height: 1,
                        width: 1,
                    },
                },
                '.section-divider': {
                    left: 0,
                    right: 0,
                    position: 'absolute',
                },

                [`&.${DividerVariants.HOME}`]: {
                    my: '85px',
                    [theme.breakpoints.up('lg')]: {
                        my: '120px',
                    },
                },

                [`&.${DividerVariants.SECTION_START}`]: {
                    mb: '19px',
                    mt: '45px',
                    [theme.breakpoints.up('lg')]: {
                        mt: '75px',
                        mb: '33px',
                    },
                },

                [`&.${DividerVariants.SECTION_END}`]: {
                    my: '85px',
                },
            }}
        >
            <MuiDivider className="section-divider" />
            <div className="divider-logo-decoration-container">
                <div className="divider-logo-decoration" />
            </div>
        </Box>
    );
};

export default Divider;
